import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';

import Note from './components/Note';
import ErrorNote from './components/ErrorNote';
import ActionRow from './components/ActionRow';
import ErrorModal from '../../shared/ErrorModal';

import {
    initEmptyNotes,
    errorMessageText,
    raceTypes,
    raceTypeNames,
    getAjaxUrl,
    validateInput,
} from './helpers';

class Notes extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            notes: initEmptyNotes(),
            isSaveDisabled: true,
            isDataSaved: false,
            error: null,
        };
        this.ajaxUrl = getAjaxUrl(this.props.data.profile.horseUid);
    }

    componentDidMount() {
        this.getNotes();
    }

    onSaveSuccess = (data) => {
        const { notes } = this.state;

        Object.keys(notes).forEach((key) => { notes[key].isExists = !!data[key]; });

        this.setState({
            notes: { ...notes },
            isSaveDisabled: true,
            isDataSaved: true,
        });
    };

    onSave = () => {
        const { notes: note } = this.state;

        axios.post(this.ajaxUrl, qs.stringify({ note }))
            .then(({ data }) => {
                const error = Object.keys(data)
                    .some(item => data[item].error);

                if (error) {
                    throw new Error();
                } else {
                    this.onSaveSuccess(data);
                }
            })
            .catch(() =>
                this.setState({ error: 'postError' })
            );
    };

    onClear = () => {
        const notes = initEmptyNotes(this.state.notes);
        raceTypes.forEach((type) => {
            notes[type].onChange = this.onChange.bind(this, type);
        });

        this.setState({ notes, isSaveDisabled: false, isDataSaved: false });
    };

    onChange = (raceType, event) => {
        const { name, value } = event.target;
        const notes = { ...this.state.notes };

        notes[raceType][name] = validateInput(name, value);

        this.setState({
            notes,
            isSaveDisabled: false,
            isDataSaved: false,
        });
    };

    getNotes = () => {
        axios.get(this.ajaxUrl)
            .then(({ data: { data, error } }) => {
                if (error) {
                    throw new Error();
                } else {
                    this.appendNotes(data);
                }
            })
            .catch(() => this.setState({ error: 'getError' }));
    };

    appendNotes = (data) => {
        const { notes } = this.state;
        const newNotes = data.reduce((acc, cur) => ({
            ...acc,
            [cur.raceTypeCode]: {
                raceType: cur.raceTypeCode,
                ratingFlag: cur.ratingFlag || '',
                rating: cur.rating,
                note: cur.comment || '',
                isExists: true,
            },
        }), notes);

        raceTypes.forEach((type) => {
            newNotes[type].onChange = this.onChange.bind(this, type);
        });

        this.setState({ notes: { ...newNotes }, error: null });
    };

    hideErrorLightbox = () => {
        this.setState({ error: null });
    };

    render() {
        const { notes, isSaveDisabled, isDataSaved, error } = this.state;
        const isGetErrorOccurred = error === 'getError';
        const isPostErrorOccurred = error === 'postError';

        return (
            <section className="hp-notes__container">
                <ActionRow
                    onSave={this.onSave}
                    onClear={this.onClear}
                    isDisabled={isSaveDisabled}
                    isSaved={isDataSaved}
                    isErrorOccurred={error}
                />
                <div className="ui-divider" />
                {Object.entries(notes).map(([type, value]) => (
                    isGetErrorOccurred ?
                        (
                            <ErrorNote
                                raceType={type}
                                raceTypeName={raceTypeNames[type]}
                                onReload={this.getNotes}
                                key={type}
                            />
                        ) : (
                            <Note
                                {...value}
                                raceTypeName={raceTypeNames[type]}
                                key={type}
                            />
                        )
                ))}
                <ActionRow
                    onSave={this.onSave}
                    onClear={this.onClear}
                    isDisabled={isSaveDisabled}
                    isSaved={isDataSaved}
                    isErrorOccurred={error}
                />
                {isPostErrorOccurred && (
                    <ErrorModal
                        text={errorMessageText}
                        onClose={this.hideErrorLightbox}
                    />
                )}
            </section>
        );
    }
}

Notes.propTypes = PropTypes.shape({
    data: PropTypes.shape({
        profile: PropTypes.shape({
            horseUid: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
}).isRequired;

export default Notes;



// WEBPACK FOOTER //
// ./src/js/horse/notes/Notes.jsx